<h1 class="h3 mb-2 text-gray-800">Envío de resultados</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Resultados de tratamiento</h6>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-6">
                <form name="form" (ngSubmit)="f.form.valid && enviarDatos()" #f="ngForm">
                    <div class="form-group">
                        <label>Enviar PDF de resultados</label>
                        <input type="file" #fileuploadTop="ngModel" [(ngModel)]="comprobante" name="comprobante" accept=".pdf"
                            (change)="seleccionarPdf($event)" class="form-control"
                            [ngClass]="{'is-invalid':  f.submitted && fileuploadTop.invalid}" required />
                        <div *ngIf="f.submitted && fileuploadTop.invalid" class="invalid-feedback">
                            <div *ngIf="fileuploadTop.errors.required">El comprobante es requerido</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="videoYoutube">URL del Video en Youtube</label>
                        <input class="form-control" name="videoYoutube" #videoYoutube="ngModel"
                            [ngClass]="{'is-invalid':  f.submitted && videoYoutube.invalid}"
                            [(ngModel)]="caso.video_entrega"/>
                        <div *ngIf="f.submitted && videoYoutube.invalid" class="invalid-feedback">
                            <div *ngIf="videoYoutube.errors.required">La URL del video es requerida</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="reunionZoom">Datos de la reunión en zoom</label>
                        <input class="form-control" name="reunionZoom" #reunionZoom="ngModel"
                            [ngClass]="{'is-invalid':  f.submitted && reunionZoom.invalid}"
                            [(ngModel)]="caso.reunionZoom"/>
                        <div *ngIf="f.submitted && reunionZoom.invalid" class="invalid-feedback">
                            <div *ngIf="reunionZoom.errors.required">La reunión de zoom es requerida</div>
                        </div>
                    </div>

                    <div class="form-group">
                        <button type="submit" class="btn btn-primary">Enviar resultado</button>&nbsp;
                        <a [routerLink]="'/casos/'+caso.id+'/verpaciente'" class="btn btn-link">Volver</a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>